module.exports = __webpack_public_path__ + "assets/images/03_4f360ae80c9e0778232c00237dd2cad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/03.png
// module id = 61
// module chunks = 0